import { QueryCache, QueryClient } from "@tanstack/react-query";
import { useAddSnackbarMessage } from "app/components/snackbar/hooks/useAddSnackbarMessage";
import { isDev } from "app/helpers/environment";

export const useCreateQueryClient = (): (() => QueryClient) => {
  const addSnackbarMessage = useAddSnackbarMessage();

  return () =>
    new QueryClient({
      queryCache: new QueryCache({
        onError: (error, query) => {
          if (typeof query.options.meta?.name === "string") {
            const queryName = query.options.meta.name;
            const messageTitle = `${queryName}: chyba načítání`;

            addSnackbarMessage({
              description: isDev() ? error.message : undefined,
              message: messageTitle,
              type: "error",
            });
          }
        },
      }),
    });
};
